<template>
 <div data-app>
  <KTCard v-bind:title="title">
      <template v-slot:body>
        <div class="m-portlet__body">



            <div class="form-group m-form__group row">

              <div class="col-lg-2">
                <label class="col-lg-12 col-form-label">Üye:</label>
                  <div class="col-lg-12">
                    <b-form-select 
                      v-model="user_id" 
                      :options="users" 
                      value-field="id" 
                      text-field="name"
                    >
                    </b-form-select>
                  </div>
              </div>

              <div class="col-lg-2">
                <label class="col-lg-12 col-form-label">&nbsp;</label>
                  <div class="col-lg-12">
                    <b-button
                      size="sm"
                      variant="primary"
                      @click="showResults(user_id)"
                    >
                    <i class="la la-filter"></i>
                        Filtrele
                    </b-button>
                    &nbsp;
                    <b-button
                      size="sm"
                      variant="success"
                      @click="resetFilters()"
                    >
                    <i class="la la-refresh"></i>
                        Temizle
                    </b-button>
                  </div>
              </div>

             

            </div>
          </div>
        
        <v-spacer></v-spacer>

      <table class="table table-hover table-bordered" id="example">
        <thead>
          <tr>
            <th></th>
            <th>İsim Soyisim</th>
            <th>Tarih</th>
            <th>İşlem Türü</th>
            <th>Tutar</th>
            
          </tr>
        </thead>
        <tbody>
          <tr v-for="stat in stats" :key="stat.id">
            <td><v-icon
                  class="la la-eye"
                  data-toggle="m-popover" title="Görüntüle"
                  @click="viewTransaction(stat.id)"
                  >
                </v-icon>
            </td>
            <td>{{ stat.user.name }}</td>
            <td>{{ stat.transaction_date | formatDate }}</td>
            <td>{{ stat.type }}</td>
            <td>{{ stat.amount }}</td>
            
          </tr>
          
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td>Toplam:</td>
            <td>{{ sum }}</td>
          </tr>
        </tfoot>
        
      </table>
    
    </template>
  </KTCard>    
</div>  
</template>
   
  <script>
  //import 'bootstrap/dist/css/bootstrap.min.css'; //for table good looks
  import KTCard from "@/view/content/Card.vue";
  import 'jquery/dist/jquery.min.js';
  //Datatable Modules
  import "datatables.net-dt/js/dataTables.dataTables"
  import "datatables.net-dt/css/jquery.dataTables.min.css"
  import "datatables.net-buttons/js/dataTables.buttons.js"
  import "datatables.net-buttons/js/buttons.colVis.js"
  import "datatables.net-buttons/js/buttons.flash.js"
  import "datatables.net-buttons/js/buttons.html5.js"
  import "datatables.net-buttons/js/buttons.print.js"

  import JSZip from 'jszip';
  window.JSZip = JSZip;
  
  import $ from 'jquery'; 
  import { GET_TRANSACTIONS_REPORT } from "@/core/services/store/transactions.module";
  import { ALL_USERS } from "@/core/services/store/users.module";

  export default {
    data: function() {
          return {
              users:[],
              user_id: '',
              title: "Üye Listesi",
              stats: [],
              sum: 0,
              transactions: [],
              name: "",
              organizational_units: [],
              organizational_unit_id: "",
              registration_number: ""
          }
      },
    
    
    methods: {
      showResults(user_id) {
        $('#example').DataTable().destroy();
          this.$store.dispatch(GET_TRANSACTIONS_REPORT, {user_id})
          .then((response) => {
              
              this.stats = response.data.records;
              this.sum = response.data.sum;
              setTimeout(function(){
                
              $('#example').DataTable(
                  {
                      pagingType: 'full_numbers',
                      pageLength: 25,
                      processing: true,
                      dom: 'Bfrtip',
                      filter: true,
                      retrieve: true,
                      searching: false,
                      paging: true,
                      responsive: true,
                      language: { "url": "assets/Turkish.json" },
                      order: [[0, 'asc']],
                      buttons: [
                      {
                          extend: 'copy',
                          text: 'Kopyala',
                          footer: true,
                          className: 'btn btn-success'
                      },
                      {
                          extend: 'excel', // Excel export button
                          text: 'Excel',
                          footer: true,
                          className: 'btn btn-success'
                      },
                      {
                          extend: 'print',
                          text: 'Yazdır',
                          footer: true,
                          className: 'btn btn-success'
                      },
                    ],
                  }
              );
            },
            1000
            );  
          })
      },

      viewTransaction(id) {
          this.$router.push({
              name: "transactions-form",
              params: { id: id, formType: "view" }
          });
      },

      resetFilters() {
        this.user_id = "";
        
        $('#example').DataTable().destroy();
        this.stats = [];
      }
    },
    
   
    components: {
       KTCard,
    },

    created() {
      this.$store.dispatch(ALL_USERS)
        .then(( response ) => {
            this.users = response.data;
        })

     
    },


  }
  </script>
  